var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{directives:[{name:"tippy",rawName:"v-tippy",value:({ placement: 'top' }),expression:"{ placement: 'top' }"}],attrs:{"title":"Add to Playlist"},on:{"click":_vm.showModal}},[_c('font-awesome-icon',{attrs:{"icon":_vm.faStream}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7e99672","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-components/activity-summary/components/secondary-actions/add-to-playlist/add-to-playlist-button.vue
// module id = WV9x
// module chunks = 1